import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function PickingListIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <path id="Vector" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M9.55979 12.9313 13.088 9.59074c0.5865 -0.55526 0.5412 -1.53819 -0.1 -2.16848 -0.626 -0.61545 -1.5809 -0.65774 -2.1327 -0.09447L7.42323 10.8309l-0.56467 2.1045c-0.08441 0.3145 0.23135 0.6331 0.54707 0.5518l2.15225 -0.554"
          strokeWidth="1"></path>
    <path id="Vector_2" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="m3.27399 4.43028 0.91974 0.85532c0.4328 -1.12112 0.79324 -1.61307 1.60955 -2.28084"
          strokeWidth="1"></path>
    <path id="Vector_3" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="m3.27399 8.18187 0.91974 0.85532c0.4328 -1.12112 0.79324 -1.61308 1.60955 -2.28084"
          strokeWidth="1"></path>
    <path id="Intersect" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M11.461 4.52942C10.4092 2.91667 9.68588 2.02967 8.39266 0.946158 8.06674 0.67309 7.65548 0.523145 7.2304 0.513432 6.8405 0.504523 6.43362 0.5 5.99994 0.5c-1.35771 0 -2.45278 0.044328 -3.5862 0.128791C1.45092 0.700541 0.692031 1.4732 0.634341 2.43697 0.546295 3.90785 0.499939 5.43445 0.499939 7c0 1.56554 0.046356 3.0922 0.134402 4.563 0.05769 0.9638 0.816549 1.7365 1.779369 1.8082 0.61829 0.0461 1.22517 0.0802 1.86949 0.1017"
          strokeWidth="1"></path>
  </SvgIcon>
}
